<div [class.darkenContent]="loading">
  <dash-banner></dash-banner>
  <router-outlet></router-outlet>
</div>
